import { createFileRoute, redirect } from '@tanstack/react-router';

import { CertificatesPage } from '@/pages/certificates';

export const Route = createFileRoute('/_user/certificates')({
  beforeLoad: async ({ context }) => {
    const user =
      context.auth.user ??
      (await context.auth.userRefetch().catch(() => null));

    if (!user) {
      throw redirect({ to: '/sign-in' });
    }
  },
  component: CertificatesPage,
});
